import React, { useState } from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import {
	PanelActionClose,
	PanelActionGroup,
	PanelBody,
	PanelContainer,
	PanelHeader,
	PanelSubheader,
	PanelTitle,
} from '@atlassian/panel-system';
import { PanelContent } from '@atlassian/panel-system/panel-content';
import { SubheaderInlineEdit } from '@atlassian/panel-system/subheader-inline-edit';

import { PanelCoverImage } from '../images/panel-cover';

// This width is only set so the panel renders at a sensible size in the docs.
// Please use the navigation-system panel slot to size panels — do not hardcode this.
const styles = cssMap({
	exampleWrapper: {
		width: '400px',
		height: '480px',
	},
});

export function SubheaderInlineEditExample(): React.JSX.Element {
	const [title, setTitle] = useState('Subheading title');

	return (
		<Box xcss={styles.exampleWrapper}>
			<PanelContainer testId="preview-panel">
				<PanelHeader>
					<PanelTitle>Page details</PanelTitle>
					<PanelActionGroup>
						<PanelActionClose onClick={() => {}} testId="close-action" />
					</PanelActionGroup>
				</PanelHeader>
				<PanelContent>
					<PanelSubheader
						title={title}
						coverImage={<PanelCoverImage />}
						inlineEdit={
							<SubheaderInlineEdit
								defaultValue={title}
								placeholder="Give this panel a title"
								editButtonLabel="Edit subheading title"
								onConfirm={(value) => setTitle(value)}
								testId="subheader-inline-edit"
							/>
						}
					/>
					<PanelBody>
						<Stack space="space.200">
							<Heading size="small" as="h3">
								Project overview
							</Heading>
							<Text>
								The subheader title above is editable in place. Select it to enter edit mode, change
								the text, then confirm or cancel.
							</Text>
						</Stack>
					</PanelBody>
				</PanelContent>
			</PanelContainer>
		</Box>
	);
}

export default SubheaderInlineEditExample;
